module.exports = __webpack_public_path__ + "static/media/continent.7aaf7075.svg";